import React from 'react';

const NextMeetings = () => {
  const meetings = [
    {
      id: 1,
      date: "October 15, 2024",
      time: "19:00",
      book: "The Midnight Library",
      author: "Matt Haig",
      location: "Englischer Garten, Munich"
    },
    {
      id: 2,
      date: "November 12, 2024",
      time: "18:30",
      book: "Klara and the Sun",
      author: "Kazuo Ishiguro",
      location: "Seehaus, Munich"
    }
  ];

  return (
    <div className="row-span-1 p-4 shadow-lg drop-shadow-lg text-slate-900 bg-slate-100 rounded-xl lg:col-span-4">
      <h2 className="pt-1 pb-4 pl-3 text-3xl font-extrabold leading-tight font-playfair-display">
        Next Meetings
      </h2>
      <div className="space-y-6">
        {meetings.map(meeting => (
          <div key={meeting.id} className="bg-white p-4 rounded-lg shadow">
            <div className="flex items-center mb-3">
              <svg className="w-5 h-5 text-purple-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
              <p className="text-lg font-semibold text-purple-700">{meeting.date} at {meeting.time}</p>
            </div>
            <div className="mb-3 pl-7">
              <p className="text-sm text-gray-600">Book:</p>
              <p className="font-medium">{meeting.book} by {meeting.author}</p>
            </div>
            <div className="flex items-center pl-7">
              <svg className="w-5 h-5 text-purple-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
              <p>{meeting.location}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NextMeetings;